export const SHOW_PRIVACY_SETTINGS_SIGNAL = 'privacySettingsExit';
